import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import DataTablePagination from './Paginate';

const PaginatedTable = ({columns, rows}) => {
  const [page, setPage] = useState(1);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      color: "#212529",
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const currentRow = rows?.slice(((page-1)*10), page*10);

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: "100%" }} aria-label="simple table">
          <TableHead sx={{borderBottom:"2px solid #000"}} >
            <StyledTableRow>
              {
                columns?.map((column, id) => (
                  <StyledTableCell sx={{width:column?.width}} >{column?.label}</StyledTableCell>
                ))
              }
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {currentRow.map((row, id) => (
              <StyledTableRow
                key={id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {
                  columns?.map((col, index) => (
                    <StyledTableCell key={id} align="left">{row[col?.field]}</StyledTableCell>
                  ))
                }
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <DataTablePagination 
        page={page}
        setPage={setPage}
        pageNumbers={rows?.length}
      />
    </div>
  )
}

export default PaginatedTable